type LinkColumnCandidate = {
  hidden?: boolean;
  key: string;
  type: string;
};

/**
 * Column that opens the readonly investment-limit summary.
 *
 * Uses the first configured text column that is not hidden in the table
 * configuration. A customization that only reorders columns does not change
 * that choice. When customization hides that column, uses the first text
 * column that is still visible. Returns null when no such text column exists.
 */
export function investmentComplianceLimitLinkColumnKey(
  configuredColumns: readonly LinkColumnCandidate[],
  customizedColumns: readonly LinkColumnCandidate[]
): string | null {
  const configuredKey =
    configuredColumns.find(
      (column) => column.type === 'text' && column.hidden !== true
    )?.key ?? null;

  if (configuredKey == null) {
    return null;
  }

  const customizedColumn = customizedColumns.find(
    (column) => column.key === configuredKey
  );
  if (customizedColumn != null && customizedColumn.hidden !== true) {
    return configuredKey;
  }

  return (
    customizedColumns.find(
      (column) => column.type === 'text' && column.hidden !== true
    )?.key ?? null
  );
}
